// Placeholder rows for Coming Soon cards; deleted as those cards go live.
import { OverviewAiInsight } from "./overview.data";

export const previewAiInsights: OverviewAiInsight[] = [
  { text: "Return requests increased 14% compared to the previous period." },
  { text: "Adjust Shipping Frequency offers were accepted 3.2% more often than last period." },
  { text: "Customers who accepted a 15% discount generated $28,000 in retained revenue." },
  { text: "Shipping delays generated 18% more support sessions than normal." },
  { text: "Subscription cancel requests decreased 12% this period." },
];


